import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { Provider } from 'react-redux';
import { store, persistor } from './store/auth/store';
import { PersistGate } from 'redux-persist/integration/react';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { ConfigProvider } from 'antd';
import esES from 'antd/es/locale/es_ES';
import { checkVersion } from './utils/checkVersion';

dayjs.locale('es');


// ✅ Verificar si hay una nueva versión antes de montar la app
checkVersion().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConfigProvider locale={esES}>
          <App />
        </ConfigProvider>
      </PersistGate>
    </Provider>
  );
});

reportWebVitals();
